module.exports = "<p>\n  Will redirect you to app\n</p>\n"